// Notifications communes aux deux apps (src/ui/feedback/toast.jsx).
// Ce module garde l'ancien chemin d'import et branche le traducteur d'erreurs.
import { ToastProvider as BaseToastProvider, useToast } from "../ui/feedback/toast";
import { getFriendlyErrorMessage } from "../utils/apiErrors";

export const ToastProvider = (props) => <BaseToastProvider formatError={getFriendlyErrorMessage} {...props} />;

export { useToast };
